module.exports = __webpack_public_path__ + "static/img/date.d2eb5c0b.png";